










































import { computed, defineComponent, ref } from '@vue/composition-api'
import { isObject } from '@/libs/objects'
import { useI18n } from 'vue-i18n-bridge'
import type { PropType } from '@vue/composition-api'

export default defineComponent({
  name: 'DeletableChips',

  props: {
    value: {
      type: Array as PropType<any[]>,
      required: true
    },
    showDeleteIcon: {
      type: Boolean,
      default: true
    },
    maxChipCount: {
      type: Number,
      default: 3
    },
    errors: {
      type: Object as PropType<{ [key: number]: string }>,
      default: () => ({})
    }
  },

  setup(props, { emit }) {
    const { t } = useI18n()

    const showMore = ref(false)

    const chips = computed((): { [key: string]: unknown; error: string; chipIndex: number }[] => {
      return props.value.map((item, chipIndex) => {
        const value = isObject(item) ? { ...item } : { value: item }
        return {
          ...value,
          error: props.errors[chipIndex] || '',
          chipIndex
        }
      })
    })

    const sortedChips = computed(() => {
      const errored = [...chips.value].filter((item) => item.error).sort((a, b) => (a.chipIndex > b.chipIndex ? 1 : -1))
      const valid = [...chips.value].filter((item) => !item.error).sort((a, b) => (a.chipIndex > b.chipIndex ? 1 : -1))

      const sorted = [...errored, ...valid]
      return showMore.value || sorted.length < 3 ? sorted : sorted.slice(0, props.maxChipCount)
    })

    const showMoreButtonText = computed(() => {
      if (showMore.value) {
        return t('Show less')
      }
      return `${t('Show more')} (+${props.value.length - props.maxChipCount})`
    })

    const deleteItem = (chipIndex: number): void => {
      const array = chips.value
        .filter((chipItem) => chipItem.chipIndex !== chipIndex)
        .map(({ error, chipIndex, ...rest }) => ({ ...rest }))

      emit('onDelete', array)
    }

    return {
      sortedChips,
      showMore,
      showMoreButtonText,
      deleteItem
    }
  }
})
